module.exports = __webpack_public_path__ + "img/admin_adv_19.65ad2d93.png";